import { useEffect } from 'react';

interface Props {
  url: string;
  onLoad?: () => void;
  onError?: () => void;
}

const loadedUrls = new Set<string>();

// Replacement for the abandoned react-load-script package.
const LoadScript = ({ url, onLoad, onError }: Props) => {
  useEffect(() => {
    if (loadedUrls.has(url)) {
      onLoad?.();
      return;
    }
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = () => {
      loadedUrls.add(url);
      onLoad?.();
    };
    script.onerror = () => onError?.();
    document.body.appendChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return null;
};

export default LoadScript;
